module.exports = __webpack_public_path__ + "static/media/icons8-whatsapp.5902f900.svg";